//************************************************//
//************************************************//
//************************************************//

export interface FilterValueJSON {
  data: any;
}
export class FilterValueModel {
  data: any;
  constructor(
    data: any
  ){
    this.data = data
  }
}
export class FilterValueFactory {
  fromJSON(json: FilterValueJSON): FilterValueModel {
    return new FilterValueModel(
      json.data
    );
  }
  toJSON(model: FilterValueModel): FilterValueJSON {
    return {
      data: model.data
    };
  }
}

/**************************************/

export type FilterType = 'BooleanField' |
                         'DateTimeField' |
                         'DateField' |
                         'WeekField' |
                         'MonthField' |
                         'CharField' |
                         'IntegerField' |
                         'DecimalField' |
                         'SelectField' |
                         'MultiSelectField' |
                         'ForeignKey'
export interface FilterMetaJSON {
  field_type: FilterType,
  object_api_name?: string
}

export class FilterMetaModel {
  fieldType: FilterType;
  objectApiName?: string

  constructor(
    fieldType: FilterType,
    objectApiName?: string
  ){
    this.fieldType=fieldType;
    this.objectApiName = objectApiName;
  }
}

export class FilterMetaFactory {
  fromJSON(json: FilterMetaJSON): FilterMetaModel {
    return new FilterMetaModel(
      json.field_type,
      json?.object_api_name
    );
  }
  toJSON(model: FilterMetaModel): FilterMetaJSON {
    const thisJSON: FilterMetaJSON = {field_type: model.fieldType}
    if(model.objectApiName) thisJSON.object_api_name = model.objectApiName
    return thisJSON
  }
}

/**************************************/


export interface FilterJSON{
  id: string;
  name: string;
  label: string;
  value: FilterValueJSON;
  meta: FilterMetaJSON;
}

export class FilterModel {
  id: string;
  name: string;
  label: string;
  value: FilterValueModel;
  meta: FilterMetaModel;

  constructor(
    id: string,
    name: string,
    label: string,
    value: FilterValueModel,
    meta: FilterMetaModel
  ){
    this.id=id;
    this.name=name;
    this.label=label;
    this.value=value;
    this.meta=meta;
  }
}

export class FilterFactory {
  fromJSON(json: FilterJSON): FilterModel {
    const value = new FilterValueFactory().fromJSON(json.value)
    const meta = new FilterMetaFactory().fromJSON(json.meta)
    return new FilterModel(
      json.id,
      json.name,
      json.label,
      value,
      meta
    );
  }
  toJSON(model: FilterModel): FilterJSON {
    const value = new FilterValueFactory().toJSON(model.value)
    const meta = new FilterMetaFactory().toJSON(model.meta)

    return {
      id: model.id,
      name: model.name,
      label: model.label,
      value: value,
      meta: meta
    };
  }
}
